<template>
  <div class='massLoss-list' v-loading='importLoading'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='110px' :inline='true'
               class='demo-form-inline flex1'>
        <el-form-item label='年月：'>
          <el-input v-model='searchForm.startYears' type='number' size='mini' placeholder='请输入年月' />
          <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
          <el-input v-model='searchForm.endYears' type='number' size='mini' placeholder='请输入年月' />
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' class='searchBtn' @click='btnClick("add")'>新增</el-button>
          <el-button size='small' class='searchBtn' @click='LockOrUnlock'>锁定/解锁</el-button>
          <el-button size='small' class='searchBtn' @click="btnClick('del')">删除</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;' class='exportButton'>
        <div style='display: flex;justify-content: flex-end;'>
          <span @click='download'>模板下载</span>
          <batch-import :uploadUrl='uploadUrl' @importSuccess='searchBtn'
                        @triggerLoading='importLoading = !importLoading' />
          <span class='mr0' @click='exportData'>导出数据</span>
        </div>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          ref='registerTable'
          row-key='id'
          v-loading='tableLoading'
          :data='tableData'
          :max-height='tableMaxHeight'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
          @select='handleCurrentChange'
          @select-all='handleCurrentChange'
          :span-method='objectSpanMethod'
          :row-style="rowStyle"
        >
          <el-table-column type='selection' align='center' width='50px' :reserve-selection='true' />
          <el-table-column prop='years' label='年份' align='center' min-width='180px' />
          <el-table-column prop='businessType' label='业务类型' align='center' min-width='180px' />
          <el-table-column prop='businessIncome' label='营业收入（含内部交易）' align='center'
                           min-width='180px' />
          <el-table-column prop='operatingCosts' label='营业成本（含内部交易）' align='center'
                           min-width='180px' />
          <el-table-column prop='netAssetValue' label='资产净值（净额金额）' align='center'
                           min-width='180px' />
          <el-table-column prop='assetIncome' label='资产收入' align='center' min-width='180px' />
          <el-table-column prop='assetCost' label='资产成本' align='center' min-width='180px' />
          <el-table-column label='锁定状态' align='center' min-width='100px'>
            <template slot-scope='scope'>
              {{ scope.row.lockingType ? '锁定' : '未锁定' }}
            </template>
          </el-table-column>
          <el-table-column label='操作' width='200px' align='center'>
            <template slot-scope='scope'>
              <el-button size='mini' type='primary' @click='btnClick("info",scope.row)'>详情
              </el-button>
              <el-button size='mini' type='primary' @click='btnClick("edit",scope.row)'>修改
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10,20,40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>

    <revenue-and-expenditure-and-net-value-form ref='RevenueAndExpenditureAndNetValueFormRef'
                                                @searchBtn='searchBtn' />
  </div>
</template>

<script>
  import {
    netOperatingValueDelete,
    netOperatingValueLockUnlock,
    netOperatingValuePage,
  } from '@/service/financial';
  import RevenueAndExpenditureAndNetValueForm
    from './components/revenueAndExpenditureAndNetValueForm.vue';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import BatchImport from '@/components/batchImport';

  export default {
    name: 'revenueAndExpenditureAndNetValue',
    components: {
      BatchImport,
      RevenueAndExpenditureAndNetValueForm,
    },
    data() {
      return {
        importLoading: false,
        searchForm: {
          startYears: '',
          endYears: '',
          page: 1,
          rows: 10,
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
        checkTableData: [],
        uploadUrl: '/operating/revenue/net/asset/value/batchExport',
        windowHeight: 0,
        tableMaxHeight: 650,
      };
    },
    watch: {
      windowHeight() {
        this.getResolution(true);
      },
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      // this.searchBtn();
      this.getResolution();
    },
    methods: {
      getResolution(flag) {
        if (flag) {
          this.windowHeight === 1080 ? this.tableMaxHeight = 650 : this.tableMaxHeight = 380;
          this.$forceUpdate();
          return;
        }
        this.windowHeight = window.screen.height;
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/operating/revenue/net/asset/value/exportData?access_token=${token}&startYears=${this.searchForm.startYears}&endYears=${this.searchForm.endYears}`;
        window.exportExcelGet('/platform/operating/revenue/net/asset/value/exportData', `startYears=${this.searchForm.startYears}&endYears=${this.searchForm.endYears}`)
      },
      btnClick(str, row) {
        switch (str) {
          case 'info':
            this.$refs.RevenueAndExpenditureAndNetValueFormRef.dialogOpen('详情', row);
            break;
          case 'edit':
            this.$refs.RevenueAndExpenditureAndNetValueFormRef.dialogOpen('编辑', row);
            break;
          case 'add':
            this.$refs.RevenueAndExpenditureAndNetValueFormRef.dialogOpen('新增');
            break;
          case 'del':
            this.deleteData();
            break;
        }
      },
      // 删除
      async deleteData() {
        if (this.checkTableData.length === 0) return this.$message.warning('请选择数据后删除');
        this.$confirm('确认删除当前选中数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const ids = [];
            this.checkTableData.forEach(item => {
              ids.push(item.associationId);
            });
            const {
              status,
              message,
            } = await netOperatingValueDelete({ ids });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.clearCheckTableData();
          })
          .catch(() => {
          });
      },
      // 锁定/解锁
      async LockOrUnlock() {
        if (this.checkTableData.length === 0) return this.$message.warning('请选择数据后锁定/解锁');
        const associationIds = [];
        this.checkTableData.forEach(item => {
          associationIds.push(item.associationId);
        });
        const {
          status,
          message,
        } = await netOperatingValueLockUnlock({ associationIds });
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.clearCheckTableData();
      },
      clearCheckTableData() {
        this.$refs.registerTable.clearSelection();
        this.checkTableData = [];
        this.getTableData();
      },
      // 查询
      searchBtn() {
        if (this.searchForm.startYears.length !== this.searchForm.endYears.length) return this.$message.warning('请保持开始日期与结束日期（年/月）一致性！');
        if (this.searchForm.endYears && this.searchForm.startYears && (this.searchForm.endYears < this.searchForm.startYears)) return this.$message.warning('结束日期必须大于等于开始日期！');
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await netOperatingValuePage(this.searchForm);
        if (status !== 0) return this.$message.warning(message);
        this.tableLoading = false;
        this.tableData = data.records;
        this.total = data.total;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      // 多选事件触发
      handleCurrentChange(val) {
        this.checkTableData = val;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      // 合并相同列
      objectSpanMethod({
                         row,
                         column,
                         rowIndex,
                         columnIndex,
                       }) {
        // data ：需要修改的列数和列的属性 第一列从0开始
        const data = [
          {
            columnIndex: 0,
          },
          {
            columnIndex: 1,
            value: 'years',
          },
          {
            columnIndex: 8,
          },
          {
            columnIndex: 9,
          },
        ];
        for (let index = 0; index < data.length; index++) {
          if (columnIndex === data[index].columnIndex) {
            const _row = this.filterData(this.tableData, data[1].value)[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
              rowspan: _row,
              colspan: _col,
            };
          }
        }
      },
      // 根据是否有相同数据返回一个如[2,0,3,0,0]格式的数组(公共的)
      filterData(arr, value) {
        let spanOneArr = [];
        let concatOne = 0;
        arr.forEach((item, index) => {
          if (index === 0) {
            spanOneArr.push(1);
          } else {
            // name 修改
            if (item[value] === arr[index - 1][value]) {
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
            } else {
              spanOneArr.push(1);
              concatOne = index;
            }
          }
        });
        return spanOneArr;
      },
      download() {
        // window.location.href = '/file/营业收支及资产净值导入模板.xlsx';
        let token = getSessionStore('token');
        window.location.href = `${baseUrl}/platform/operating/revenue/net/asset/value/export?access_token=${token}`;

      },
    },
  };
</script>


<style lang='scss' scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }


        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }


    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }

            }

          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }

        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }
    }

  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }


  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      margin-right: 10px;
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
